var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mku_front"}},[_c('vue-progress-bar'),_c('header-component'),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }